import React, { useState, useEffect } from "react";
import { Page } from "../../layout/page";

import {
	ENUM_FORM_DISPLAY,
	ENUM_FORM_LAYOUT_CONTAINER,
} from "../../components/pageList";
import { useFormRender } from "../../hooks/useFormRender";
import { useServerApi } from "../../hooks/userServerApi";
import _ from "lodash";
import PageListHeader from "../../components/pageListHeader";
import { TextInput } from "@mantine/core";
import ReactJson from "react-json-view";
import ImagePicker from "../../components/imagePicker";
import { useTabNavigate } from "../../hooks/useTabNavigate";
import { useTranslation } from "react-i18next";

const DEFAULT_ORGANIZATION = {
	name: "",
	cname: "",
	shortName: "",
	address: "",
	caddress: "",
	email: "",
	tel: "",
	fax: "",
	website: "",
	image: "",
};

const prepareOrganizationSetting = (setting) => ({
	...setting,
	organization: {
		...DEFAULT_ORGANIZATION,
		...(setting?.organization || {}),
	},
});

const formSchema = {
	title: "Organization",
	apiEntity: "setting",
	display: {
		mode: ENUM_FORM_DISPLAY.INSIDE,
		size: "xl", //xs, sm, xl  ....100%
		// position:"right"
	},
	initialValues: {
		organization: { ...DEFAULT_ORGANIZATION },
	},
	prepareLoadedData: prepareOrganizationSetting,
	layout: {
		containers: [
			{
				key: "basic-g",
				parent: null,
				type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
				cols: [
					{
						key: "basic-g1",
						props: {
							span: 9,
							mt: 0,
						},
					},
					{
						key: "basic-g2",
						props: {
							span: 3,
						},
					},
				],
			},

			{
				key: "section1",
				parent: "basic-g1",
				type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
				props: {
					title: "Basic Info",
					description: "Please fill in details",
				},
			},
			{
				key: "section4",
				parent: "basic-g2",
				type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
				props: {
					title: "Company Logo",
					// Match the Basic Info subtitle so the two cards start on the same line.
					description: "\u00a0",
				},
			},
			{
				key: "section2",
				parent: null,
				type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
				props: {
					title: "Contact Info",
					description: "Please fill in details",
				},
			},
			{
				key: "section3",
				parent: null,
				type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
				props: {
					title: "Address",
					description: "Please fill in details",
				},
			},
		],
		fields: [
			{
				name: "organization.image",
				component: ImagePicker,
				parent: "section4",
				props: {
					size: 160,
				},
			},
			{
				name: "organization.name",
				component: TextInput,
				parent: "section1",
				props: {
					label: "English Name",
				},
			},
			{
				name: "organization.cname",
				component: TextInput,
				parent: "section1",
				props: {
					label: "Chinese Name",
				},
			},
			{
				name: "organization.shortName",
				component: TextInput,
				parent: "section1",
				props: {
					label: "Short Name",
				},
			},
			{
				name: "organization.address",
				component: TextInput,
				parent: "section3",
				props: {
					label: "Address",
				},
			},
			{
				name: "organization.caddress",
				component: TextInput,
				parent: "section3",
				props: {
					label: "Address (Chinese)",
				},
			},
			{
				name: "organization.website",
				component: TextInput,
				parent: "section2",
				props: {
					label: "Website",
				},
			},
			{
				name: "organization.email",
				component: TextInput,
				parent: "section2",
				props: {
					label: "Email",
				},
			},
			{
				name: "organization.tel",
				component: TextInput,
				parent: "section2",
				props: {
					label: "Tel.",
				},
			},
			{
				name: "organization.fax",
				component: TextInput,
				parent: "section2",
				props: {
					label: "Fax",
				},
			},
		],
	},
};
const Organization = () => {
	// const [rates, setRates] = useState([]);
	const { t } = useTranslation();
	const [api] = useServerApi();
	const tabNav = useTabNavigate();
	const [renderForm, formAction] = useFormRender(formSchema);

	const fetchSetting = async () => {
		try {
			const result = await api.search({
				apiEntity: "setting",
				pageSize: 1,
			});

			if (!result || _.isEmpty(result.docs)) {
				formAction.open({
					mode: "add",
					data: prepareOrganizationSetting({}),
				});
				return;
			}

			const setting = result.docs[0];
			formAction.open({
				mode: "edit",
				id: setting._id,
				data: prepareOrganizationSetting(setting),
			});
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		fetchSetting();
	}, []);

	const handleSave = () => {
		formAction.save();
	};

	const handleClose = () => {
		tabNav.closeActive();
	};

	return (
		<Page>
			{/* <ReactJson src={setting} /> */}
			<PageListHeader
				title={t("Organization")}
				actionButtons={[
					{ label: t("Save"), onClick: () => handleSave() },
					{
						label: t("Close"),
						onClick: handleClose,
						variant: "default",
					},
				]}
			/>
			{renderForm()}
		</Page>
	);
};

export default Organization;
